<ng-container *ngIf="call">
  <!-- Minimized: a compact pill that keeps the call one click away. -->
  <button
    type="button"
    class="cc-pill"
    *ngIf="minimized"
    [class.cc-pill-live]="isLive"
    (click)="toggleMinimized()"
    aria-label="Expand call"
  >
    <span class="cc-dot"></span>
    <span class="cc-pill-name">{{ contactName }}</span>
    <span class="cc-pill-time">{{ call.phase === 'in_call' ? elapsed : statusLabel }}</span>
    <i class="bi bi-arrows-angle-expand"></i>
  </button>

  <section class="cc-panel" *ngIf="!minimized" role="dialog" aria-label="Call">
    <header class="cc-head" [attr.data-phase]="call.phase">
      <div class="cc-head-bar">
        <span class="cc-status">
          <span class="cc-dot"></span>
          {{ statusLabel }}
        </span>
        <div class="cc-head-actions">
          <button type="button" class="cc-icon" (click)="toggleMinimized()" title="Minimise" aria-label="Minimise">
            <i class="bi bi-dash-lg"></i>
          </button>
          <button type="button" class="cc-icon" *ngIf="!isLive" (click)="close()" title="Close" aria-label="Close">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
      </div>

      <div class="cc-avatar" [class.cc-avatar-pulse]="call.phase === 'ringing' || call.phase === 'connecting'">
        <span *ngIf="initials; else personIcon">{{ initials }}</span>
        <ng-template #personIcon><i class="bi bi-person-fill"></i></ng-template>
      </div>

      <div class="cc-name" [title]="contactName">{{ contactName }}</div>
      <div class="cc-sub" *ngIf="call.request.contactSubtitle">{{ call.request.contactSubtitle }}</div>
      <div class="cc-number" *ngIf="call.request.contactName">{{ formatNumber(call.request.number) }}</div>

      <div class="cc-timer" *ngIf="call.phase === 'in_call' || (call.phase === 'ended' && call.answeredAt)">{{ elapsed }}</div>
    </header>

    <div class="cc-from" *ngIf="call.callerId && call.phase !== 'unavailable'">
      <i class="bi bi-shield-check"></i>
      Calling from <strong>{{ formatNumber(call.callerId) }}</strong>
    </div>

    <!-- Not connected: explain, and offer the softphone instead. -->
    <div class="cc-body" *ngIf="call.phase === 'unavailable'">
      <div class="cc-alert">
        <i class="bi bi-plug"></i>
        <span>{{ call.message }}</span>
      </div>
      <div class="cc-actions">
        <button type="button" class="cc-btn cc-btn-ghost" (click)="close()" [disabled]="saving">Close</button>
        <button type="button" class="cc-btn cc-btn-primary" (click)="useSoftphone()" [disabled]="saving">
          <i class="bi bi-telephone-outbound"></i> Use softphone
        </button>
      </div>
    </div>

    <!-- Live call -->
    <div class="cc-body" *ngIf="isLive">
      <div class="cc-keypad" *ngIf="showKeypad">
        <div class="cc-keypad-display">{{ dialled || ' ' }}</div>
        <button type="button" class="cc-key" *ngFor="let k of keypad" (click)="press(k.digit)" [disabled]="call.phase !== 'in_call'">
          <span class="cc-key-digit">{{ k.digit }}</span>
          <span class="cc-key-letters">{{ k.letters }}</span>
        </button>
      </div>

      <div class="cc-controls">
        <button type="button" class="cc-ctrl" [class.cc-ctrl-on]="call.muted" (click)="toggleMute()" [disabled]="call.phase !== 'in_call'">
          <i class="bi" [ngClass]="call.muted ? 'bi-mic-mute-fill' : 'bi-mic-fill'"></i>
          <span>{{ call.muted ? 'Unmute' : 'Mute' }}</span>
        </button>
        <button type="button" class="cc-ctrl" [class.cc-ctrl-on]="showKeypad" (click)="toggleKeypad()">
          <i class="bi bi-grid-3x3-gap-fill"></i>
          <span>Keypad</span>
        </button>
        <button type="button" class="cc-ctrl" [class.cc-ctrl-on]="call.onHold" (click)="toggleHold()" [disabled]="call.phase !== 'in_call'">
          <i class="bi" [ngClass]="call.onHold ? 'bi-play-fill' : 'bi-pause-fill'"></i>
          <span>{{ call.onHold ? 'Resume' : 'Hold' }}</span>
        </button>
      </div>

      <textarea
        class="cc-notes"
        rows="2"
        [(ngModel)]="notes"
        placeholder="Take notes during the call…"
        maxlength="5000"
      ></textarea>

      <button type="button" class="cc-hangup" (click)="hangUp()" aria-label="Hang up">
        <i class="bi bi-telephone-x-fill"></i>
        {{ call.phase === 'in_call' ? 'End call' : 'Cancel' }}
      </button>
    </div>

    <!-- Wrap-up -->
    <div class="cc-body" *ngIf="call.phase === 'ended'">
      <div class="cc-alert cc-alert-error" *ngIf="call.message">
        <i class="bi bi-exclamation-triangle"></i>
        <span>{{ call.message }}</span>
      </div>

      <div class="cc-label">Outcome</div>
      <div class="cc-chips">
        <button
          type="button"
          class="cc-chip"
          *ngFor="let o of outcomeOptions"
          [class.cc-chip-on]="outcome === o[0]"
          (click)="outcome = o[0]"
        >{{ o[1] }}</button>
      </div>

      <div class="cc-label">Notes</div>
      <textarea class="cc-notes" rows="3" [(ngModel)]="notes" placeholder="What was discussed?" maxlength="5000"></textarea>

      <div class="cc-actions">
        <button type="button" class="cc-btn cc-btn-ghost" (click)="close()" [disabled]="saving">Skip</button>
        <button type="button" class="cc-btn cc-btn-primary" (click)="saveAndClose()" [disabled]="saving || !call.callLogId">
          {{ saving ? 'Saving…' : 'Save call' }}
        </button>
      </div>
    </div>
  </section>
</ng-container>
